import { useContext } from "react";

import classes from "./CartIngredients.module.css";

import CartIngredientBar from "../CartIngredientBar/CartIngredientBar";

import CartContext from "../../../store/cart-context";


// component for all ingredients in cart
const CartIngredients = () => {
  const cartCtx = useContext(CartContext);

  let cartIngredients;

  // map all ingredients in cart to bar
  if (cartCtx.ingredients) {
    cartIngredients = Object.entries(cartCtx.ingredients).map(
      ([key, value]) => {
        return (
          <CartIngredientBar
            key={key}
            title={key}
            volume={value.volume}
            image={value.image}
            unit={value.unit}
          />
        );
      }
    );
  } else {
    cartIngredients = <div></div>;
  }

  return <div className={classes.cart_ingredients}>{cartIngredients}</div>;
};

export default CartIngredients;
